<!--
 * @Description: 
 * @Date: 2021-02-04 10:39:28
-->
<template>
  <div class="living-cover">
    <div>
      <!-- 抽奖计时 -->
      <div
        ref="countdown"
        v-if="showCountdown"
        class="living-cover__countdown"
        @click="showDraw"
        style="margin-bottom: .5rem;"
      >
        <img src="@/static/img/living/cj.png" style="width:1.4rem;" />
        <p style="text-align:center;">{{ time | formatTime }}</p>
      </div>
      <!-- 邀请卡 -->
      <img
        class="living-cover__invitation"
        v-if="shareList.length && !isEnd"
        src="@/static/img/living/yq.png"
        @click="jump"
      />
    </div>
    <draw v-if="drawVisible" @done="drawDone" @close="close"></draw>
    <receive-info
      v-if="recveiveVisible"
      @done="close"
      @close="close"
    ></receive-info>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import { setBeforeRegisterUrl } from '@/utils/storage';
import receiveInfo from './receiveInfo';
import draw from './draw';

const completeTime = time => {
  return (time + '').padStart(2, '0');
};

export default {
  name: 'LivingCover',
  data() {
    return {
      inter: null, // 计时器
      time: 0, // 倒计时
      recveiveVisible: false, // 收货弹层
      drawVisible: false, // 抽奖弹层
      loading: false
    };
  },
  components: { receiveInfo, draw },
  watch: {
    livingStatus: {
      handler() {
        this.time = (this.raffle.viewTime || 0) * 1000 * 60; // 抽奖限制时间
        // 直播中 && 有抽奖 && 没参与 则触发计时
        if (this.isLiving && this.raffle.id && !this.isRaffled) {
          this.setInterval();
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapState({
      shareList: state => state.living.shareList,
      raffle: state => state.living.raffle,
      detail: state => state.living.detail,
      drawResult: state => state.living.drawResult,
      isRaffled: state => state.living.isRaffled,
      livingStatus: state => state.living.livingStatus,
      user: state => state.user.info
    }),
    isLiving() {
      return this.livingStatus === 2;
    },
    isEnd() {
      return this.livingStatus === 3;
    },
    // 是否显示抽奖：有抽奖配置 && 没有提交 && 直播中
    showCountdown() {
      return this.raffle.id && !this.isRaffled && this.isLiving;
    }
  },
  methods: {
    ...mapActions('living', ['onDraw']),
    ...mapMutations('living', ['SET_COMMON']),
    close() {
      this.SET_COMMON({ field: 'coverVideo', value: false });
      this.drawVisible = false;
      this.recveiveVisible = false;
    },
    // 抽奖完成
    drawDone(status) {
      if (status === 'error') {
        this.drawVisible = false;
        this.close();
      } else {
        // 设为已抽奖
        this.SET_COMMON({ field: 'isRaffled', value: true });
        // 中奖显示弹层，未中用户手动关闭
        if (this.drawResult.showReceive) {
          this.drawVisible = false;
          // 是否为需要填写用户信息
          this.recveiveVisible = true;
        }
      }
    },
    async showDraw() {
      if (!this.user.id) {
        setBeforeRegisterUrl();
        this.$router.push({ name: 'register' });
        return;
      }
      // 倒计时完成 && 直播中
      if (!this.time && !this.loading && this.isLiving) {
        this.drawVisible = true;
        // 隐藏视频
        this.SET_COMMON({ field: 'coverVideo', value: true });
      }
    },
    setInterval() {
      this.inter && clearInterval(this.inter);
      this.inter = setInterval(() => {
        // 计时完成改为可点样式
        if (this.time <= 0) {
          this.$refs.countdown.className +=
            '  living-cover__countdown--tolerable';
          clearInterval(this.inter);
          return;
        }
        // this.$refs.countdown.className = 'living-cover__countdown';
        this.time -= 1000;
      }, 1000);
    },
    jump() {
      this.$router.push({
        name: 'livingShareCard'
      });
    }
  },
  created() {
    this.entryTime = +new Date();
    this.SET_COMMON({ field: 'coverVideo', value: false });
  },
  beforeDestroy() {
    this.inter && clearInterval(this.inter);
  },
  filters: {
    formatTime(v) {
      let date = new Date(v);
      let hour = completeTime(date.getUTCHours());
      let minute = completeTime(date.getMinutes());
      let second = completeTime(date.getSeconds());
      return `${hour}:${minute}:${second}`;
    }
  }
};
</script>

<style scoped lang="scss">
.living-cover {
  position: fixed;
  bottom: 3.6rem;
  right: 0.45rem;
  &__countdown {
    margin-bottom: 0.53rem;
    box-shadow: 0px 0.15rem 0px 0px #f2fcff;
    img {
      width: 1.4rem;
      height: 1.13rem;
      filter: grayscale(100%);
    }
    p {
      text-align: center;
      color: #1749fc;
      font-size: 0.32rem;
    }
    &--tolerable {
      img {
        filter: grayscale(0);
      }
    }
  }
  &__invitation {
    width: 1.4rem;
    height: 1.13rem;
  }
}
</style>
